import GuiContext from "config/context/guiContext";
import { useCallback, useContext, useState } from "react";
import { useGetDatabaseStructureService } from "./useGetDatabaseStructureService";
import { useInvalidateMemory } from "features/memory";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useDropComposition = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { getDatabaseStructure } = useGetDatabaseStructureService();
    const invalidateMemory = useInvalidateMemory();
    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const dropComposition = async ({ private_key, composition }) => {
        setLoading(true);
        try {
            const res = await fetch(`${URL}/api/database/drop`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                    composition: composition,
                    permission: "active",
                    private_key: private_key
                }),
            });

            const data = await res.json();
            setResponse(data);
            if (data?.status) {
                getDatabaseStructure();
                // Drop oslobađa memoriju na lancu isto kao i brisanje cele
                // baze, samo manje — keš i tu mora da se poništi.
                invalidateMemory();
            }
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    }

    const resetServerStatus = useCallback(() => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }, [])

    return {
        response,
        loading,
        error,
        dropComposition,
        resetServerStatus
    }
}